export interface Language {
	id: string;
	name: string;
}

export interface CrudForm {
	mode: 'create' | 'update' | 'read' | undefined;
}

export class OutputMessageDTO {
	topicName: string;
	action?: string;
	user?: string;
	value: any;
	date?: Date;

	constructor(data: any) {
		this.topicName = data?.topicName;
		this.action = data?.action;
		this.user = data?.user;
		this.date = data?.date;
	}
}

export class MessageSystemNavigationDTO extends OutputMessageDTO {
	constructor(data: OutputMessageDTO) {
		super(data);
		if (data.value) {
			const { action } = JSON.parse(data.value);
			this.action = action;
		}
	}
}

export class MessageSystemDTO extends OutputMessageDTO {
	version?: string;

	constructor(data: OutputMessageDTO) {
		super(data);
		if (data.value) {
			const { version } = JSON.parse(data.value);
			this.version = version;
		}
	}
}
